// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"f31638ef","132":"c43db213","384":"316b790d","453":"9512effd","462":"26d8805a","593":"d4ac7192","639":"9272e9d9","681":"7b33c6d3","855":"7d738100","880":"ee1732ba","929":"77890d1d"}[chunkId] + ".chunk.js";
};